var _920 = require('./patch/9.2.0');

module.exports = [].concat(_920);


//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/compiled/titans/dp/dp.js
// module id = 530
// module chunks = 0